import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

export const Butterfly = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/butterfly-1.png" size={size} alt="butterfly" />
)
